export default "/fonts/vendor/socicon/socicon.ttf?578ecee55f406ce82f5b6ec864568f84";